import script from "./CurrentForSaleTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentForSaleTable.vue?vue&type=script&setup=true&lang=js"

import "./CurrentForSaleTable.vue?vue&type=style&index=0&id=637900a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637900a2"]])

export default __exports__